/**
 * useDrawStyles.ts
 * Hook for managing MapboxDraw styles configuration
 */

import { useMemo } from "react";

export const useDrawStyles = () => {
  return useMemo(
    () => [
      // polygon fill
      {
        id: "gl-draw-polygon-fill-active",
        type: "fill",
        filter: ["all", ["==", "$type", "Polygon"], ["==", "active", "true"]],
        paint: {
          "fill-color": "#4C7DFB",
          "fill-outline-color": "#3bb2d0",
          "fill-opacity": 0.4
        }
      },
      // polygon outline stroke
      // This doesn't style the first edge of the polygon, which uses the line stroke styling instead
      {
        id: "gl-draw-polygon-stroke-active",
        type: "line",
        filter: ["all", ["==", "$type", "Polygon"], ["==", "active", "true"]],
        layout: {
          "line-cap": "round",
          "line-join": "round"
        },
        paint: {
          "line-color": "#101010",
          "line-width": 2
        }
      },
      // vertex points
      {
        id: "gl-draw-polygon-and-line-vertex-active",
        type: "circle",
        filter: [
          "all",
          ["==", "meta", "vertex"],
          ["==", "$type", "Point"],
          ["!=", "mode", "static"],
          ["==", "active", "true"]
        ],
        paint: {
          "circle-radius": 3,
          "circle-color": "#616161"
        }
      },
      // INACTIVE vertex points
      {
        id: "gl-draw-polygon-and-line-vertex-inactive",
        type: "circle",
        filter: [
          "all",
          ["==", "meta", "vertex"],
          ["==", "$type", "Point"],
          ["!=", "mode", "static"],
          ["==", "active", "false"]
        ],
        paint: {
          "circle-radius": 3,
          "circle-color": "#616161",
          "circle-stroke-color": "#fff",
          "circle-stroke-width": 1
        }
      },
      // polygon fill
      {
        id: "gl-draw-polygon-fill-inactive",
        type: "fill",
        filter: [
          "all",
          ["==", "active", "false"],
          ["==", "$type", "Polygon"],
          ["!=", "mode", "static"]
        ],
        paint: {
          "fill-color": "#4C7DFB",
          "fill-outline-color": "#3bb2d0",
          "fill-opacity": 0.4
        }
      },
      // polygon outline
      {
        id: "gl-draw-polygon-stroke-inactive",
        type: "line",
        filter: [
          "all",
          ["==", "active", "false"],
          ["==", "$type", "Polygon"],
          ["!=", "mode", "static"]
        ],
        layout: {
          "line-cap": "round",
          "line-join": "round"
        },
        paint: {
          "line-color": "#4C7DFB",
          "line-width": 2
        }
      },
      // polygon midpoint icon
      {
        id: "gl-draw-polygon-midpoint",
        type: "circle",
        filter: ["all", ["==", "$type", "Point"], ["==", "meta", "midpoint"]],
        paint: {
          "circle-radius": 3,
          "circle-color": "#616161"
        }
      },
      // static
      {
        id: "gl-draw-polygon-fill-static",
        type: "fill",
        filter: ["all", ["==", "mode", "static"], ["==", "$type", "Polygon"]],
        paint: {
          "fill-color": "#4C7DFB",
          "fill-outline-color": "#3bb2d0",
          "fill-opacity": 0.4
        }
      },
      {
        id: "gl-draw-polygon-stroke-static",
        type: "line",
        filter: ["all", ["==", "mode", "static"], ["==", "$type", "Polygon"]],
        layout: {
          "line-cap": "round",
          "line-join": "round"
        },
        paint: {
          "line-color": "#4C7DFB",
          "line-width": 2
        }
      },
      {
        id: "gl-draw-line-static",
        type: "line",
        filter: [
          "all",
          ["==", "mode", "static"],
          ["==", "$type", "LineString"]
        ],
        layout: {
          "line-cap": "round",
          "line-join": "round"
        },
        paint: {
          "line-color": "#404040",
          "line-width": 2
        }
      },
      {
        id: "gl-draw-point-static",
        type: "circle",
        filter: ["all", ["==", "mode", "static"], ["==", "$type", "Point"]],
        paint: {
          "circle-radius": 5,
          "circle-color": "#404040"
        }
      },
      // active line
      {
        id: "gl-draw-line-active",
        type: "line",
        filter: [
          "all",
          ["==", "$type", "LineString"],
          ["==", "active", "true"]
        ],
        layout: {
          "line-cap": "round",
          "line-join": "round"
        },
        paint: {
          "line-color": "#101010",
          "line-width": 2
        }
      }
    ],
    []
  );
};
